/*
NOTE TO DEVELOPERS:

The purpose of glom is to provide a global space into which arbitrary
information can be placed. Each piece of information MUST be set to a default
value below such that any other javascript, system-wide, may use said piece of
information without fear of it not being available
*/
let glom = {
    /** @type { number | null } */
    alertConfigId: null,
    /** @type { number | null } */
    weatherAlertConfigurationId: null,
    titleId: '',
    originalTitle: '',
    locale: 'en-us',
    /**
     * Default `'auto'` otherwise a string of numbers
     * @type {('auto' | string)}
     */
    windowScale: 'auto',
    effectiveWindowScale: NaN,
    /**
     * @deprecated use `./urlOverrides.ts isInsideCms()` instead.
     */
    insideCMS: false,
    /**
     * @type {?string}
     * @deprecated use `./urlOverrides.ts getPostbackUrl()` instead.
     */
    postbackURL: null,
    playerXDimension: 0,
    playerYDimension: 0,
    /** @type {?string} */
    playerUuid: null,
    /** @type {?string} */
    securityToken: null,
    dailyRestartWindow: {
        /** @type {?string} */
        begin: null,
        /** @type {?string} */
        end: null,
    },
    maxLoopSlots: 180,
    timezone: 'auto', //note: this gets over-written below, if necessary
    allowCursor: false,
    showNetworkStates: ['degraded', 'down'],
    prefetchAssets: [
        //list of digital assets to prefetch if ImageCache service is available
        '/images/network-status-ok.png',
        '/images/network-status-degraded.png',
        '/images/network-status-down.png',
    ],
};

export { glom };
